﻿window.cObjetDocCptMetier = function (objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetTableUpdateLib = function () { return ["doc_cpt"] }

    this.mGetLibBase = function () {
        if (typeof objet.data == 'undefined') {
            return "Document comptable";
        } else {
            return this.mGetNomDocument()
        }
    }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouveau document comptable"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') {
            txt = this.mGetNomDocument() + " " + this.mGetLibIdDocument()
            switch (parseInt(objet.data.id_statut_com)) {
                case 1:
                    //txt += " <span style='font-size:80%'>(" + objet.data.dcr.toDDMMMAA() + ")</span>"
                    txt += " " + this.mGetEtatHtml()
                    break;
                case 2:
                    //txt += " validé";
                    //switch (parseInt(objet.data.id_type_com)) {
                    //    case 2: case 3:
                    //        txt += "e"
                    //        break;
                    //    default: break;
                    //}
                    if (objet.data.date_document != null) txt += "<br/><span style='font-size:70%'>" + objet.data.date_document.toDDMMAA() + "&bull;" + objet.data.date_document.toHHMM() + "</span>"
                    txt += " " + this.mGetEtatHtml()

                    if (objet.data.id_mode_reglement_attendu != null && objet.data.id_doc_cpt_facture_valide == null) {
                        var modeReg = Me.objet.bddRef.mGetArray("mode_reglement").filter(function (o) { return o.id_mode_reglement == objet.data.id_mode_reglement_attendu })[0]
                        txt += " (Attente " + modeReg.nom + ")"
                    }
                    break;
            }
        }
        else {
            txt = "Document comptable"
        }
        if (typeof option != 'undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetLibDetailDocument = function () {
        var libDoc = ""
        switch (parseInt(objet.data.id_type_com)) {
            case 1: libDoc = "Devis"; break;
            case 2: libDoc = "Commande"; break;
            case 3: libDoc = "Facture"; break;
        }
        if (parseInt(objet.data.id_statut_com) == 1) {
            libDoc += " #" + objet.data.id_doc_cpt
            libDoc += " <span style='color:red'>brouillon</span>"
            libDoc += " " + objet.data.dmo.toDDMMAAAA()
        } else {
            var soc = objet.bddRef.getObjet("societe", objet.data.id_societe)
            var entete = ""
            switch (parseInt(objet.data.id_type_com)) {
                case 1: entete = soc.data.entete_devis; break;
                case 2: entete = soc.data.entete_commande; break;
                case 3: entete = soc.data.entete_facture; break;
            }
            libDoc += " " + entete + objet.data.id_document
            libDoc += " <span style='color:green'>validé</span>"
            libDoc += " " + objet.data.date_document.toDDMMAAAA()
        }
        return libDoc
    }

    this.mGetNomfilePdf = function () {
        var libDoc = ""
        switch (parseInt(objet.data.id_type_com)) {
            case 1: libDoc = "Devis"; break;
            case 2: libDoc = "Commande"; break;
            case 3: libDoc = "Facture"; break;
        }
        if (parseInt(objet.data.id_statut_com) == 1) {
            libDoc += " num" + objet.data.id_doc_cpt
            libDoc += " brouillon"
            libDoc += " " + objet.data.dmo.toDDMMAAAA().remplacerTout("/", "")
        } else {
            var soc = objet.bddRef.getObjet("societe", objet.data.id_societe)
            var entete = objet.data.entete_document_valide
            if (!entete || entete.length > 0) {
                switch (parseInt(objet.data.id_type_com)) {
                    case 1: entete = soc.data.entete_devis; break;
                    case 2: entete = soc.data.entete_commande; break;
                    case 3: entete = soc.data.entete_facture; break;
                }
            }
            libDoc += " " + entete + objet.data.id_document
            libDoc += " " + objet.data.date_document.toDDMMAAAA().remplacerTout("/", "")
        }
        return libDoc + ".pdf"
    }

    this.mGetLstCasExoTva = function () {
        return [
            { id: 1, text: 'Client B2C hors UE (export)', phrase: "Exonération de TVA<br/>exportation hors UE (article 262 I du CGI)" },
            { id: 2, text: 'Client B2B en UE hors France', phrase: "Autoliquidation<br/>TVA due par le preneur (article 283-2 du CGI)" },
            { id: 3, text: 'Client B2B hors UE (export)', phrase: "Exonération de TVA<br/>exportation hors UE (article 262 I du CGI)" },
        ]
    }

    this.mGetEtatHtml = function () {
        var txt = ""
        switch (parseInt(objet.data.id_statut_com)) {
            case 1:
                txt = "<span style='color:" + theme.toastError + "'>Brouillon</span>"
                break;
            case 2:
                //if ((objet.data.id_type_com == "1" || objet.data.id_type_com == "2") && objet.data.id_doc_cpt_facture_valide != null) {
                //    txt = "<span style='color:" + theme.toastSuccess + "'>Soldé</span>"
                //} else {
                //if ((objet.data.id_type_com == "3" || objet.data.id_type_com == "5") && objet.data.reste_a_payer == 0) {
                if (objet.data.reste_a_payer == 0) {
                    txt += "<span style='color:" + theme.toastSuccess + "'>Soldé</span>"
                } else {
                    txt += "<span style='color:" + theme.toastWarning + "'>Validé</span>"
                }
                //}
                break;
        }
        return txt
    }

    this.mGetEtat = function () {
        var txt = ""
        switch (parseInt(objet.data.id_statut_com)) {
            case 1:
                txt = "Brouillon"
                break;
            case 2:
                if ((objet.data.id_type_com == "1" || objet.data.id_type_com == "2") && objet.data.id_doc_cpt_facture_valide != null) {
                    txt = "Soldé"
                } else {
                    if ((objet.data.id_type_com == "3" || objet.data.id_type_com == "5") && objet.data.reste_a_payer == 0) {
                        txt += "Soldé"
                    } else {
                        txt += "Validé"
                    }
                }
                break;
        }
        return txt
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetWidthPopup = function () {
        if ((objet.data.id_type_com == "4" || objet.data.id_type_com == "5") && objet.data.id_statut_com == "2") {
            return 540
        } else {
            if (objet.data.id_type_com == "5") { return 1000 }
            else { return 800 }
        }
    }
    this.mGetPaddingPopup = function () {
        return 20
    }

    this.mGetNomDocument = function () {
        var txt = ""
        switch (parseInt(objet.data.id_type_com)) {
            case 1: txt = "Devis"; break;
            case 2: txt = "Commande"; break;
            case 3: txt = "Facture"; break;
            case 4: txt = "Note"; break;
            case 5: txt = "Ticket"; break;
        }
        return txt
    }

    this.mGetLibIdDocument = function () {
        var txt = ""
        if (objet.data.id_document == null) {
            txt = "ID<sup style='font-size:60%'>(#" + objet.data.id_doc_cpt + ")</sup>"
        } else {
            var entete = this.mGetEnteteNumDocument()
            txt = ((entete.length == 0) ? "N°" : entete) + objet.data.id_document
        }
        return txt
    }

    this.mGetUnUne = function () {
        var txt = ""
        switch (parseInt(objet.data.id_type_com)) {
            case 1: txt = "un"; break;
            case 2: txt = "une"; break;
            case 3: txt = "une"; break;
            case 4: txt = "un"; break;
            case 5: txt = "un"; break;
        }
        return txt
    }

    this.mGetIcone = function (dataTemplate) {
        var $Icone = null
        var toolTip = ""
        if (typeof dataTemplate == 'undefined') { $Icone = $("<i class='fafa fafa-file-invoice-euro'></i>"); }
        else {
            $Icone = $("<i class='fafa fafa-file-invoice-euro' style='position:relative;color:" + theme.color + ";'></i>");
            var txt = ""
            switch (parseInt(dataTemplate.id_type_com)) {
                case 1: txt = "D"; toolTip = "Devis"; break;
                case 2: txt = "C"; toolTip = "Commande"; break;
                case 3: txt = "F"; toolTip = "Facture"; break;
                case 4:
                    $Icone = $("<i class='fas fa-receipt' style='position:relative;color:" + theme.color + ";'></i>");
                    txt = "N";
                    toolTip = "Note";
                    break;
                case 5:
                    $Icone = $("<i class='fas fa-receipt' style='position:relative;color:" + theme.color + ";'></i>");
                    txt = "T";
                    toolTip = "Ticket";
                    break;
            }
            $("<div style='position:absolute;top:-2px;left:-2px;color:" + theme.backgroundcolorAccent + ";font-size:100%;font-family: fantasy;font-weight:100;'>" + txt + "</div>").appendTo($Icone)
            switch (parseInt(dataTemplate.id_statut_com)) {
                case 1: $("<i class='fas fa-pen' style='position:absolute;bottom:-2px;right:-3px;color:" + theme.backgroundcolorAccent + ";font-size:50%;'></i>").appendTo($Icone); break;
                case 2: $("<i class='fas fa-lock' style='position:absolute;bottom:-2px;right:-3px;color:" + theme.backgroundcolorAccent + ";font-size:50%;'></i>").appendTo($Icone); break;
            }
        }
        $Icone.attr("title", toolTip)
        //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $Icone, position: "bottom", contentTemplate: function (contentElement) { contentElement.text(toolTip) } })
        return $Icone
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
        return $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlGridDocCpt({
            bddCtrl: Me.objet.bddRef,
            titleElementCmd: option.titleElementCmd
        }).dxCtrlGridDocCpt("instance")
    }

    this.mGetItemTemplateHeight = function (type) {
        return ((type == "Détails") ? 73 : 53)
    }
    this.mGetNomFromTemplate = function (dataTemplate) {
        var nomDocument = ""
        switch (parseInt(dataTemplate.id_type_com)) {
            case 1: nomDocument = "Devis"; break;
            case 2: nomDocument = "Commande"; break;
            case 3: nomDocument = "Facture"; break;
            case 4: nomDocument = "Note"; break;
            case 5: nomDocument = "Ticket"; break;
        }
        return nomDocument
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        if (dataTemplate.facturx_id_statut == 213) {
            if (dataTemplate.fini == "1") {
                contentElement.closest(".divtemplate").addClass("texture_import_disable_projet_pipeline")
            }
            else {
                contentElement.closest(".divtemplate").removeClass("texture_import_disable_projet_pipeline")
            }
            contentElement.css("text-decoration", "line-through")
        }


        var $TdUti = $("<td style='width:20px;padding:0 3px;height:1px;'/>")
        $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdUti).dxCtrlImgSimpleStrConUti({
            bddCtrl: objet.bddRef,
            idTable: objet.bddRef.getObjet("utilisateur").mGetTable().id_table,
            id: dataTemplate.id_utilisateur,
            text: ((dataTemplate.id_utilisateur == null) ? "" : objet.bddRef.getObjet("utilisateur", dataTemplate.id_utilisateur).mGetLib1())
        })

        var $TdSociete = null
        var dataSociete = objet.bddRef.mGetArray("societe").filter(function (o) { return o.id_societe == dataTemplate.id_societe })[0]
        if (objet.bddRef.objCptCli.data.multi_societe == "1") {
            $TdSociete = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:100px;font-weight:bold;font-variant:small-caps;'>" + dataSociete.nom + "</td>")
            $TdSociete.attr("title", dataSociete.nom)
        }

        var $TdDest = $("<td style='width:20px;padding:0 3px;height:1px;'/>")
        var $TdNomclient = null
        if (dataTemplate.id_table_client == null) {
            $("<div style='width:18px;height:18px;border-radius:50%;opacity:0.5;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                icon1: "fas fa-circle-question",
                text: ""
            })
        } else {
            $("<div style='width:18px;height:18px;border-radius:50%;'/>").appendTo($TdDest).dxCtrlImgSimpleStrConUti({
                bddCtrl: objet.bddRef,
                icon1: "fas fa-portrait",
                icon2: "",
                idTable: dataTemplate.id_table_client,
                id: dataTemplate.id_client,
                text: dataTemplate.nom_client
            })
        }
        var contenuClient = ((dataTemplate.id_table_client == null) ? "(Aucun client)" : ((dataTemplate.nom_client == null || dataTemplate.nom_client.length == 0) ? "CLIENT SANS NOM" : dataTemplate.nom_client)) + " &bull; <span style='font-size:80%;" + ((dataTemplate.reste_a_payer > 0) ? "color:red" : ((dataTemplate.reste_a_payer < 0) ? "color:green" : "")) + "'>Reste à payer:</span><span style='" + ((dataTemplate.reste_a_payer > 0) ? "color:red" : ((dataTemplate.reste_a_payer < 0) ? "color:green" : "")) + "'>" + parseFloat(dataTemplate.reste_a_payer).round().formatDisplay() + "€</span></span>"
        $TdNomclient = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:50%;'>" + contenuClient + "</td>")
        $TdNomclient.attr("title", contenuClient)

        var nomDocument = ""
        switch (parseInt(dataTemplate.id_type_com)) {
            case 1: nomDocument = "Devis"; break;
            case 2: nomDocument = "Commande"; break;
            case 3: nomDocument = "Facture"; break;
            case 4: nomDocument = "Note"; break;
            case 5: nomDocument = "Ticket"; break;
        }
        var $TdLibDoc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;' title='" + nomDocument + "'>" + nomDocument + "</td>")

        var txt = ""
        var toolTip = ""
        if (dataTemplate.id_document == null) {
            txt = "ID<sup style='font-size:60%'>(#" + dataTemplate.id_key + ")</sup>"
            toolTip = "ID#" + dataTemplate.id_key
        } else {
            var entete = ""
            switch (parseInt(dataTemplate.id_type_com)) {
                case 1: entete = dataTemplate.entete_devis; break;
                case 2: entete = dataTemplate.entete_commande; break;
                case 3: entete = dataTemplate.entete_facture; break;
                case 4: entete = dataTemplate.entete_recapitulatif; break;
                case 5: entete = dataTemplate.entete_ticket; break;
                default: entete = ""; break;
            }
            txt = ((entete.length == 0) ? "N°" : entete) + dataTemplate.id_document
            toolTip = txt
        }
        var $TdNumDoc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;' title='" + toolTip + "'>" + txt + "</td>")

        var txt = ""
        switch (parseInt(dataTemplate.id_statut_com)) {
            case 1:
                txt = "<span style='color:" + theme.toastError + "' title='Brouillon'>Brouillon</span>"
                break;
            case 2:
                if (dataTemplate.reste_a_payer <= 0) {
                    txt += "<span style='color:" + theme.toastSuccess + "' title='Soldé'>Soldé</span>"
                } else {
                    txt += "<span style='color:" + theme.toastWarning + "' title='Validé'>Validé</span>"
                }
                break;
        }
        var $TdEtatDoc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;'>" + txt + "</td>")

        var $TdHt = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;text-align:right;position:relative;'></td>")
        //var $TdTva = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:85px;text-align:right;'></td>").appendTo($Tr)
        var $TdTtc = $("<td style='overflow:hidden;text-overflow:ellipsis;padding:0 3px;width:10%;text-align:right;position:relative;'></td>")
        if (dataTemplate.assujetti_tva == "1") {
            $("<span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>HT</span>").appendTo($TdHt)
            $("<span title='HT: " + dataTemplate.totht_avec_remise_pied + "€'>" + parseFloat(dataTemplate.totht_avec_remise_pied).round().formatDisplay() + "€</span>").appendTo($TdHt)
            //$("<span><span class='dx-field-item-label-text' style='font-size:70%'>TVA:</span>" + parseFloat(dataTemplate.tottva_avec_remise_pied).round().formatDisplay() + "€</span>").appendTo($TdTva)
            $("<span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>TTC</span>").appendTo($TdTtc)
            $("<span title='TTC: " + dataTemplate.totttc_avec_remise_pied + "€'>" + parseFloat(dataTemplate.totttc_avec_remise_pied).round().formatDisplay() + "€</span>").appendTo($TdTtc)
        } else {
            $TdHt.css("display", "none")
            //$TdTva.css("display", "none")
            $TdTtc.css("width", "160px")
            $("<span class='dx-field-item-label-text' style='font-size:50%;position:absolute;right:2px;top:-7px;'>Tot.Net TVA</span>").appendTo($TdTtc)
            $("<span title='Tot.Net TVA: " + dataTemplate.totttc_avec_remise_pied + "€'>" + parseFloat(dataTemplate.totttc_avec_remise_pied).round().formatDisplay() + "€</span>").appendTo($TdTtc)
        }
        if (parseFloat(dataTemplate.totttc_avec_remise_pied) < 0) $TdTtc.css("color", "red")

        //var $TdEncaiss = null
        //if (!objet.bddRef.isDemo && objet.bddRef.objCptCli.data.offre_essai == "0" && parametre.lst_nombase_pa.contains(objet.bddRef.nom_base)) {
        //    if (Me.mPA210CanEncaisse(dataTemplate)) {
        //        $TdEncaiss = $("<td style='width:80px;text-align:right;padding-left:5px;font-family:barlow condensed;'/>")
        //        var $A = $("<a href='javascript:void(0)'>Encaisser sur PA</a>").appendTo($TdEncaiss)
        //        $A.attr("title", "Marquer cette facture comme encaissée sur le PA du client")
        //        $A.on("click", function (e) {
        //            e.stopPropagation()
        //            Me.mPA210Encaisse(dataTemplate, $A, function () { $A.hide() })
        //        })
        //    }
        //}

        ////gestion PA
        //var ligneStatutPa = ((typeof parametre !== "undefined" && parametre.lst_statut_envoi_pa) || []).filter(function (s) {
        //    return s.facturx_id_statut === dataTemplate.facturx_id_statut
        //})[0]
        //var $TablePa = null
        //if (dataSociete.has_pa == "1" && ligneStatutPa) {
        //    var $TablePa = $("<table style='table-layout:fixed;width:100%;line-height:1;font-family:barlow condensed;'/>")
        //    var $TrPa = $("<tr/>").appendTo($TablePa)
        //    var $TdIconePa = null
        //    $TdIconePa = $("<td style='width:26px;padding:0 3px;height:1px;font-size:20px;'/>").appendTo($TrPa)
        //    $("<i class='fafa fafa-pa' style='color:" + ligneStatutPa.couleur_icone + "'></i>").appendTo($TdIconePa)
        //    $TdIconePa.attr("title", "<div style='color:" + ligneStatutPa.couleur_icone + "'/>" + ligneStatutPa.facturx_id_statut + ":" + ligneStatutPa.facturx_statut + "</div>" + ligneStatutPa.facturx_detail)

        //    $TdDetailPa = $("<td style='width:100%;height:1px;white-space:normal;'/>").appendTo($TrPa)
        //    $TdDetailPa.html("<span style='color:" + ligneStatutPa.couleur_icone + "'/>" + ligneStatutPa.facturx_id_statut + ":" + ligneStatutPa.facturx_statut + "</span> " + ligneStatutPa.facturx_detail)
        //    if (ligneStatutPa.avec_message_erreur) $("<span> " + dataTemplate.dernier_message_erreur + "</span>").appendTo($TdDetailPa)
        //    if (ligneStatutPa.codes_reponse_possibles.length > 0) {
        //        var $TdSelectPa = $("<td style='width:100px;height:1px;white-space:normal;'/>").appendTo($TrPa)
        //        $("<div/>").appendTo($TdSelectPa).dxCtrlDocCptSelectActionPA({
        //            bddCtrl: objet.bddRef,
        //            ligneStatutPa: ligneStatutPa,
        //            lst_statut_pa: parametre.lst_statut_envoi_pa,
        //            idDocCpt: dataTemplate.id_doc_cpt
        //        })
        //    }
        //}
        //if (dataSociete.has_pa == "1" && ligneStatutPa &&
        //    (dataTemplate.facturx_id_statut == 206 || dataTemplate.facturx_id_statut == 207 || dataTemplate.facturx_id_statut == 208)) {
        //    //on attend une réponse sur cette facture
        //    $TdDetailPa = $("<td style='width:100%;height:1px;'/>")
        //    $("<i class='fafa fafa-pa' style='color:" + ligneStatutPa.couleur_icone + "'></i>").appendTo($TdDetailPa)
        //    $TdDetailPa.html("<span style='color:" + ligneStatutPa.couleur_icone + "'/>" + ligneStatutPa.facturx_id_statut + ":" + ligneStatutPa.facturx_statut + "</span> " + ligneStatutPa.facturx_detail)
        //    if (ligneStatutPa.avec_message_erreur) $("<span> " + dataTemplate.dernier_message_erreur + "</span>").appendTo($TdDetailPa)
        //    if (dataTemplate.facturx_id_statut == 208) {
        //        var $AReponse = $("<a href='javascript:void(0)'>Répondre a votre client</a>").appendTo($TdEncaiss).appendTo($TdDetailPa)
        //        $AReponse.attr("title", "Votre client attend une réponse de votre part")
        //        $AReponse.on("click", function (e) {
        //            Me.mPA209Repondre(function () {
        //                $AReponse.hide()
        //            })
        //        })
        //    }
        //}


        if (type == "Lignes") {
            var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            if ($TdSociete) $TdSociete.appendTo($Tr)
            $TdNomclient.appendTo($Tr)
            $TdLibDoc.appendTo($Tr)
            $TdNumDoc.appendTo($Tr)
            $TdEtatDoc.appendTo($Tr)
            $TdHt.appendTo($Tr)
            $TdTtc.appendTo($Tr)
            $TdUti.appendTo($Tr)
            $TdDest.appendTo($Tr)
            //if ($TdIconePa) $TdIconePa.appendTo($Tr)
            //if ($TdEncaiss) $TdEncaiss.appendTo($Tr)

        } else {
            var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            if ($TdSociete) $TdSociete.appendTo($Tr)
            $TdNomclient.appendTo($Tr); $TdNomclient.css("width", "100%")
            $TdUti.appendTo($Tr)
            $TdDest.appendTo($Tr)
            //if ($TdIconePa) $TdIconePa.appendTo($Tr)
            //if ($TdEncaiss) $TdEncaiss.appendTo($Tr)

            var $Table = $("<table style='table-layout:fixed;width:100%;'/>").appendTo(contentElement)
            var $Tr = $("<tr/>").appendTo($Table)
            //$("<td style='width:25%'/>").appendTo($Tr)
            $TdLibDoc.appendTo($Tr); $TdLibDoc.css("width", "20%");
            $TdNumDoc.appendTo($Tr); $TdNumDoc.css("width", "20%");
            $TdEtatDoc.appendTo($Tr); $TdEtatDoc.css("width", "20%");
            $TdHt.appendTo($Tr); $TdHt.css("width", "20%");
            $TdTtc.appendTo($Tr); $TdTtc.css("width", "20%");

        }

        if (dataSociete.has_pa == "1" && dataTemplate.id_statut_com == "2" && dataTemplate.id_type_com == "3") {
            $("<div/>").appendTo(contentElement).dxCtrlDisplayPA({
                bddCtrl: objet.bddRef,
                typeDisplay: "grille",
                lst_statut_pa: parametre.lst_statut_envoi_pa,
                data: dataTemplate
            })
        }

    }
    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        if (dataPlus.date_document == null) {
            $("<span style='' title='Créé le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
        } else {
            $("<span style='' title='Validé le " + dataPlus.date_document.toFrenchDateTime() + "'><i class='fafa fafa-file-invoice-euro dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.date_document.toDateIlya(true) + "</span>").appendTo(contentElement)
        }
    }

    this.itemTemplateCard = function (contentElement) {
        var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
        objet.mGetIcone().appendTo($Td)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        var txt = Me.mGetLib1() + " ⚉ Tot.TTC:" + parseFloat(objet.data.totttc_avec_remise_pied).round().formatDisplay() + "€"
        $Td.html(txt)
    }

    this.isPopupFullScreen = true
    //this.mShowPopup = function (option) {
    //    if (typeof option == 'undefined') option = {}
    //    option.fullScreen = true
    //    page.mAddPopup(objet.data, option)
    //}
    this.contentTemplatePopup = function (contentElement, option) {
        contentElement.empty();
        $("<div/>").appendTo(contentElement).dxCtrlDocCpt({
            bddCtrl: Me.objet.bddRef,
            idDocCpt: objet.data.id_doc_cpt,
            optionPopup: option
        })
    }

    this.mGetSociete = function () {
        return Me.objet.bddRef.mGetArray("societe").filter(function (o) { return o.id_societe == objet.data.id_societe })[0]
    }
    this.mGetEnteteNumDocument = function () {
        var dataSoc = this.mGetSociete()
        switch (parseInt(objet.data.id_type_com)) {
            case 1: return dataSoc.entete_devis; break;
            case 2: return dataSoc.entete_commande; break;
            case 3: return dataSoc.entete_facture; break;
            case 4: return dataSoc.entete_recapitulatif; break;
            case 5: return dataSoc.entete_ticket; break;
            default: return ""; break;
        }
    }

    this.mGetDocCptSociete = function (funcOk) {
        //Me.objet.bddRef.mAjaxCall({ command: "getdatas", nomtable: "doc_cpt_societe", sql: "select * from doc_cpt_societe where id_doc_cpt=" + objet.data.id_doc_cpt }, function (data) {
        Me.objet.bddRef.mAjaxCall({ command: "getdatasdoccptsociete", id: objet.data.id_doc_cpt }, function (data) {
            data.doc_cpt_societe = JSON.parse(data.doc_cpt_societe)
            if (typeof data.doc_cpt_societe == "undefined") debugger;
            funcOk(data.doc_cpt_societe[0])
        });
    }

    this.mGetDocCptClient = function (funcOk) {
        Me.objet.bddRef.mAjaxCall({ command: "getdatasdoccptclient", id: objet.data.id_doc_cpt }, function (data) {
            data.doc_cpt_client = JSON.parse(data.doc_cpt_client)
            funcOk(data.doc_cpt_client[0])
        });
    }

    ////update l'objet doccptclient avec le client passer en objet
    ////return true si changement
    //this.mUpdateDocCptClient = function (docCptClient, objClient) {
    //    if (typeof objClient == 'undefined') objClient = null
    //    if (docCptClient.id != null && objClient == null) {
    //        objClient = Me.objet.bddRef.getObjet(Me.objet.bddRef.table.mGetItem(docCptClient.id_table).nom, docCptClient.id)
    //    }
    //    if (docCptClient) {
    //        var change = false
    //        if (objClient == null) {
    //            if (docCptClient.nom != null) { change = true; docCptClient.nom = null }
    //            if (docCptClient.ad1 != null) { change = true; docCptClient.ad1 = null }
    //            if (docCptClient.cp != null) { change = true; docCptClient.cp = null }
    //            if (docCptClient.ville != null) { change = true; docCptClient.ville = null }
    //            if (docCptClient.cedex != null) { change = true; docCptClient.cedex = null }
    //            if (docCptClient.pays != null) { change = true; docCptClient.pays = null }
    //            if (docCptClient.tva_intra != null) { change = true; docCptClient.tva_intra = null }
    //            if (docCptClient.adresse_email != null) { change = true; docCptClient.adresse_email = null }
    //            if (docCptClient.id != null) { change = true; docCptClient.id = null }
    //            if (docCptClient.id_table != null) { change = true; docCptClient.id_table = null }
    //            if (docCptClient.has_client != 0) { change = true; docCptClient.has_client = 0 }
    //            if (docCptClient.nom_base != null) { change = true; docCptClient.nom_base = null }
    //        } else {
    //            if (docCptClient.nom != objClient.mGetLib1()) { change = true; docCptClient.nom = objClient.mGetLib1(); }
    //            if (docCptClient.id != objClient.cle()) { change = true; docCptClient.id = objClient.cle() }
    //            if (docCptClient.id_table != objClient.mGetTable().id_table) { change = true; docCptClient.id_table = objClient.mGetTable().id_table }
    //            if (docCptClient.id_table == Me.objet.bddRef.getObjet("compte_client").mGetTable().id_table) {
    //                //on est sur un compte client
    //                if (docCptClient.ad1 != objClient.data.ad1) { change = true; docCptClient.ad1 = objClient.data.ad1 }
    //                if (docCptClient.cp != objClient.data.cp) { change = true; docCptClient.cp = objClient.data.cp }
    //                if (docCptClient.ville != objClient.data.ville) { change = true; docCptClient.ville = objClient.data.ville }
    //                if (docCptClient.pays != objClient.data.pays) { change = true; docCptClient.pays = objClient.data.pays }
    //                if (docCptClient.tva_intra != objClient.data.tva_intra) { change = true; docCptClient.tva_intra = objClient.data.tva_intra }
    //                if (docCptClient.adresse_email != objClient.data.email) { change = true; docCptClient.adresse_email = objClient.data.email }
    //                if (docCptClient.nom_base != objClient.data.nom_base) { change = true; docCptClient.nom_base = objClient.data.nom_base }
    //            } else {
    //                var champTableData = new cTableChampData(bddRef, objClient.objetMetier.mGetLstChampTableData())
    //                var adr = champTableData.mGetAdressePostaleDefaut()
    //                if (adr == null) {
    //                    if (docCptClient.ad1 != null) { change = true; docCptClient.ad1 = null }
    //                    if (docCptClient.cp != null) { change = true; docCptClient.cp = null }
    //                    if (docCptClient.ville != null) { change = true; docCptClient.ville = null }
    //                    if (docCptClient.cedex != null) { change = true; docCptClient.cedex = null }
    //                    if (docCptClient.pays != null) { change = true; docCptClient.pays = null }
    //                } else {
    //                    var adrLib = ""
    //                    if (typeof adr.ad1 != 'undefined' && adr.ad1 != null && adr.ad1.length > 0) adrLib = adr.ad1
    //                    if (typeof adr.ad2 != 'undefined' && adr.ad2 != null && adr.ad2.length > 0) adrLib = ((typeof adr.ad2 != 'undefined' && adr.ad2 != null && adrLib.length > 0) ? ", " : "") + adr.ad2
    //                    if (typeof adr.ad3 != 'undefined' && adr.ad3 != null && adr.ad3.length > 0) adrLib = ((typeof adr.ad3 != 'undefined' && adr.ad3 != null && adrLib.length > 0) ? ", " : "") + adr.ad3
    //                    if (docCptClient.ad1 != ((adrLib.length == 0) ? null : adrLib)) { change = true; docCptClient.ad1 = ((adrLib.length == 0) ? null : adrLib) }
    //                    if (docCptClient.cp != ((typeof adr.cp == 'undefined' || adr.cp.length == 0) ? null : adr.cp)) { change = true; docCptClient.cp = ((typeof adr.cp == 'undefined' || adr.cp.length == 0) ? null : adr.cp) }
    //                    var villeCedex = ((typeof adr.ville != 'undefined' && adr.ville != null) ? adr.ville : "") + ((typeof adr.cedex != 'undefined' && adr.cedex != null && adr.cedex.length > 0) ? " " + adr.cedex : "")
    //                    if (docCptClient.ville != ((villeCedex.length == 0) ? null : villeCedex)) {
    //                        change = true; docCptClient.ville = ((villeCedex.length == 0) ? null : villeCedex)
    //                    }
    //                    if (docCptClient.pays != ((typeof adr.pays == 'undefined' || adr.pays == null || adr.pays.length == 0) ? null : adr.pays)) { change = true; docCptClient.pays = ((typeof adr.pays == 'undefined' || adr.pays == null || adr.pays.length == 0) ? null : adr.pays) }
    //                }
    //                var email = champTableData.mGetAdresseEmailDefaut()
    //                if (email == null) {
    //                    if (docCptClient.adresse_email != null) { change = true; docCptClient.adresse_email = null }
    //                } else {
    //                    if (docCptClient.adresse_email != email.valeur) { change = true; docCptClient.adresse_email = email.valeur }
    //                }
    //                if (objClient.mGetTable().nom == "structures" || objClient.mGetTable().nom == "structures_contact") {
    //                    if (objClient.mGetTable().nom == "structures_contact") { objClient = Me.objet.bddRef.getObjet(objClient.objetMetier.mGetDataStructures()) }
    //                    var champTableData = objClient.objetMetier.mGetLstChampTableData()
    //                    champTableData = champTableData.filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_tvaintra })[0]
    //                    if (typeof champTableData == "undefined" || champTableData.valeur == null || champTableData.valeur.length == 0) {
    //                        if (docCptClient.tva_intra != null) { change = true; docCptClient.tva_intra = null }
    //                    } else {
    //                        if (docCptClient.tva_intra != champTableData.valeur) { change = true; docCptClient.tva_intra = champTableData.valeur }
    //                    }
    //                }
    //            }
    //        }
    //        return change
    //    } else { return false }
    //}

    ////update l'objet doccptsociete avec la societe passer en objet
    ////return true si changement
    //this.mUpdateDocCptSociete = function (docCptSociete, objSociete) {
    //    if (typeof objSociete == 'undefined') objSociete = null
    //    if (objSociete == null) {
    //        objSociete = Me.objet.bddRef.getObjet("societe", objet.data.id_societe)
    //    }
    //    if (docCptSociete != null) {
    //        var change = false
    //        for (var prop in docCptSociete) {
    //            if (typeof objSociete.data[prop] != 'undefined' && objSociete.data[prop] != docCptSociete[prop]) {
    //                docCptSociete[prop] = objSociete.data[prop]
    //                change = true
    //            }
    //        }
    //        return change
    //    } else { return false }
    //}

    //this.mGetDataClient = function (docCptClient, objClient, funcOk) {
    //    if (docCptClient == null) {
    //        this.mGetDocCptClient(function (data) { docCptClient = data; mInitDataClient(); })
    //    } else { mInitDataClient() }

    //    function mInitDataClient() {
    //        var dataClient = {
    //            nom: null,
    //            ad1: null,
    //            cp: null,
    //            ville: null,
    //            cedex: null,
    //            pays: null,
    //            tva_intra: null,
    //            adresse_email: null,
    //            id: null,
    //            id_table: null,
    //            nom_base: null
    //        }
    //        if (objet.data.id_statut_com == "2") {
    //            //on prend les datas du doccptclient
    //            dataClient.nom = docCptClient.nom
    //            dataClient.ad1 = docCptClient.ad1
    //            dataClient.cp = docCptClient.cp
    //            dataClient.ville = docCptClient.ville
    //            dataClient.cedex = docCptClient.cedex
    //            dataClient.pays = docCptClient.pays
    //            dataClient.tva_intra = docCptClient.tva_intra
    //            dataClient.adresse_email = docCptClient.adresse_email
    //        } else {
    //            if (docCptClient.id != null && objClient == null) {
    //                objClient = Me.objet.bddRef.getObjet(Me.objet.bddRef.table.mGetItem(docCptClient.id_table).nom, docCptClient.id)
    //            }
    //            if (objClient != null) {
    //                dataClient.nom = objClient.mGetLib1()
    //                dataClient.id = objClient.cle()
    //                dataClient.id_table = objClient.mGetTable().id_table
    //                if (docCptClient.id_table == Me.objet.bddRef.getObjet("compte_client").mGetTable().id_table) {
    //                    //on est sur un compte client
    //                    dataClient.ad1 = objClient.data.ad1
    //                    dataClient.cp = objClient.data.cp
    //                    dataClient.ville = objClient.data.ville
    //                    dataClient.pays = objClient.data.pays
    //                    dataClient.tva_intra = objClient.data.tva_intra
    //                    dataClient.adresse_email = objClient.data.email
    //                    dataClient.nom_base = objClient.data.nom_base
    //                } else {
    //                    var champTableData = new cTableChampData(bddRef, objClient.objetMetier.mGetLstChampTableData())
    //                    var adr = champTableData.mGetAdressePostaleDefaut()
    //                    if (adr == null) {
    //                        dataClient.ad1 = null
    //                        dataClient.cp = null
    //                        dataClient.ville = null
    //                        dataClient.cedex = null
    //                        dataClient.pays = null
    //                    } else {
    //                        var adrLib = ""
    //                        if (typeof adr.ad1 != 'undefined' && adr.ad1 != null && adr.ad1.length > 0) adrLib = adr.ad1
    //                        if (typeof adr.ad2 != 'undefined' && adr.ad2 != null && adr.ad2.length > 0) adrLib = ((typeof adr.ad2 != 'undefined' && adr.ad2 != null && adrLib.length > 0) ? ", " : "") + adr.ad2
    //                        if (typeof adr.ad3 != 'undefined' && adr.ad3 != null && adr.ad3.length > 0) adrLib = ((typeof adr.ad3 != 'undefined' && adr.ad3 != null && adrLib.length > 0) ? ", " : "") + adr.ad3
    //                        dataClient.ad1 = ((adrLib.length == 0) ? null : adrLib)
    //                        dataClient.cp = ((typeof adr.cp == 'undefined' || adr.cp.length == 0) ? null : adr.cp)
    //                        var villeCedex = ((typeof adr.ville != 'undefined' && adr.ville != null) ? adr.ville : "") + ((typeof adr.cedex != 'undefined' && adr.cedex != null && adr.cedex.length > 0) ? " " + adr.cedex : "")
    //                        dataClient.ville = ((villeCedex.length == 0) ? null : villeCedex)
    //                        dataClient.pays = ((typeof adr.pays == 'undefined' || adr.pays == null || adr.pays.length == 0) ? null : adr.pays)
    //                    }
    //                }
    //                var email = champTableData.mGetAdresseEmailDefaut()
    //                if (email != null) dataClient.adresse_email = email.valeur

    //                if (objClient.mGetTable().nom == "structures" || objClient.mGetTable().nom == "structures_contact") {
    //                    if (objClient.mGetTable().nom == "structures_contact") { objClient = Me.objet.bddRef.getObjet(objClient.objetMetier.mGetDataStructures()) }
    //                    var champTableData = objClient.objetMetier.mGetLstChampTableData()
    //                    champTableData = champTableData.filter(function (o) { return o.id_champ_table == parametre.champ.id_champ_table_tvaintra })[0]
    //                    if (typeof champTableData == "undefined" || champTableData.valeur == null || champTableData.valeur.length == 0) {
    //                        dataClient.tva_intra = null
    //                    } else {
    //                        dataClient.tva_intra = champTableData.valeur
    //                    }
    //                }
    //            }
    //        }

    //        funcOk(dataClient)
    //    }
    //}

    this.mGetLstLigne = function (funcOk) {
        //Me.objet.bddRef.mAjaxCall({ command: "getdatas", nomtable: "doc_cpt_ligne", sql: "select * from doc_cpt_ligne where id_doc_cpt=" + objet.data.id_doc_cpt }, function (data) {
        Me.objet.bddRef.mAjaxCall({ command: "getdatasdoccptligne", id: objet.data.id_doc_cpt }, function (data) {
            data.doc_cpt_ligne = JSON.parse(data.doc_cpt_ligne)
            funcOk((typeof data.doc_cpt_ligne == 'undefined') ? [] : data.doc_cpt_ligne);
        });
    }

    //this.mGeneredocument = function () {
    //    this.mGetDocCptSociete(function (docCptSociete) {
    //        this.mGetDocCptClient(function (docCptClient) {
    //            this.mGetLstLigne(function (lstLigne) {
    //                var partDoc = { lstLigne: [] }
    //                if (objet.data.id_type_com != "4" && objet.data.id_type_com != "5") {
    //                    partDoc.entete_page = mGenerePartDocument(docCptSociete.entete_page, docCptSociete, docCptClient)
    //                }
    //                partDoc.entete_doc = mGenerePartDocument(docCptSociete.entete_doc, docCptSociete, docCptClient)
    //                lstLigne.forEach(function (ligne) {
    //                    partDoc.lstLigne.poush(mGenerePartDocument(docCptSociete.ligne, docCptSociete, docCptClient, ligne))
    //                })
    //                partDoc.pied_doc = mGenerePartDocument(docCptSociete.pied_doc, docCptSociete, docCptClient)
    //                if (objet.data.id_type_com != "4" && objet.data.id_type_com != "5") {
    //                    partDoc.pied_page = mGenerePartDocument(docCptSociete.pied_page, docCptSociete, docCptClient)
    //                }

    //                Me.objet.bddRef.mAjaxCall({ command: "generepdfdoccpt", partdoccpt: partDoc }, function (data) {

    //                });
    //            })
    //        })
    //    })
    //}

    function mGenerePartDocument(modeleHtml, docCptSociete, docCptClient, ligne) {
        var lstChampPresent = this.mGetLstChampData(modeleHtml)
        var $Div = $("<div/>")
        $Div.html(modeleHtml)
        lstChampPresent.forEach(function (champ) {
            $Div.find(".fielddoccpt_" + champ.display).each(function (idx, $ele) {
                $ele.replaceWith("ouououou")
            });
        })
        return $Div.html()
    }

    this.mGetLstChampData = function (modeleHtml, lstChampPresent) {
        if (typeof lstChampPresent == 'undefined') lstChampPresent = []
        var $Div = $("<div/>")
        $Div.html(modeleHtml)
        var lst = $Div.find(".fielddoccpt")
        for (var i = 0; i < lst.length; i++) {
            if ($(lst[i]).attr("class").split(" ").filter(function (o) { return o.startsWith("fielddoccpt_") }).length == 0) continue
            var nomChamp = $(lst[i]).attr("class").split(" ").filter(function (o) { return o.startsWith("fielddoccpt_") })[0].replace("fielddoccpt_", "")
            if (lstChampPresent.filter(function (o) { return o.display == nomChamp }).length == 0) {
                var champ = mGetChamp(nomChamp)
                lstChampPresent.push(champ)
                if (typeof champ == 'undefined') debugger;
                if (typeof champ.remplace != 'undefined') {
                    champ.remplace.forEach(function (displayChamp) {
                        if (lstChampPresent.filter(function (o) { return o.display == displayChamp }).length == 0) {
                            var champRemplace = mGetChamp(displayChamp)
                            lstChampPresent.push(champRemplace)
                        }
                    })
                }
            }
        }
        return lstChampPresent

        function mGetChamp(display) {
            var result = mGetChampInterne({ items: Me.lstChampPage })
            if (typeof result != 'undefined') return result
            return mGetChampInterne({ items: Me.lstChampLigne })

            function mGetChampInterne(item) {
                if (item.display == display) return item
                if (typeof item.items != 'undefined') {
                    for (var i = 0; i < item.items.length; i++) {
                        var result = mGetChampInterne(item.items[i])
                        if (typeof result != 'undefined') return result
                    }
                }
            }
        }
    }

    this.lstChampPage = [{
        name: 'Page',
        icon: "fas fa-file",
        items: [{
            name: 'N° de page',
            display: "NPage",
            icon: 'fas fa-file-prescription',
        }, {
            name: 'Nbre de page',
            display: "NbPage",
            icon: 'fas fa-file-prescription'
        }],
    }, {
        name: 'Ma société',
        icon: 'fas fa-building-columns',
        items: [{
            name: 'logo, nom & coordonnées',
            items: [{
                icon: "fas fa-image",
                name: 'logo',
                nombdd: "societe.logo",
                display: 'LogoSoc'
            }, {
                name: 'Nom société',
                display: "NomSoc",
                nombdd: "societe.nom",
                obligatoire: ["T", "R", "F"]
            }, {
                icon: 'fas fa-map-location-dot',
                name: 'Adresse société',
                display: "AdrSoc",
                nombdd: "societe.adr",
                obligatoire: ["T", "R", "F"]
            }, {
                icon: 'fas fa-map-location-dot',
                name: 'Code postal société',
                nombdd: "societe.cp",
                display: "CPSoc",
                obligatoire: ["T", "R", "F"]
            }, {
                icon: 'fas fa-map-location-dot',
                name: 'Ville société',
                nombdd: "societe.ville_cedex",
                display: "VilSoc",
                obligatoire: ["T", "R", "F"]
            }, {
                icon: 'fas fa-map-location-dot',
                name: 'Pays société',
                nombdd: "societe.pays",
                display: 'PaySoc',
                obligatoire: ["T", "R", "F"]
            }, {
                beginGroup: true,
                icon: "fas fa-phone",
                nombdd: "societe.telephone",
                name: 'Téléphone société',
                display: 'TelSoc'
            }, {
                icon: "fas fa-at",
                name: 'Email société',
                nombdd: "societe.email",
                display: "EmaSoc"
            }, {
                icon: "fas fa-globe",
                name: 'Site web société',
                nombdd: "societe.site_web",
                display: 'SiteWebSoc'
            }]
        }, {
            icon: 'fas fa-award',
            name: 'Siret, TVA...',
            items: [{
                icon: 'fas fa-award',
                name: 'Assujetissement TVA',
                display: "Assujetti.TVA",
                nombdd: "societe.assujetti_tva",
                obligatoire: ["F", "T"],
                htttc: ["HT"]
            }, {
                icon: 'fas fa-award',
                name: 'Forme juridique',
                display: "F.Juridique",
                nombdd: "societe.forme_juridique",
                obligatoire: ["F"]
            }, {
                icon: 'fas fa-award',
                name: 'Capital social',
                display: "Cap.Soc.",
                nombdd: "societe.capital_social",
                obligatoire: ["F"]
            }, {
                icon: "fas fa-percent",
                name: 'N° de tva intracommunautaire',
                nombdd: "societe.tva_intra",
                display: "TVAIntraSoc",
                obligatoire: ["T", "R", "F"],
                htttc: ["TTC"]
            }, {
                icon: 'fas fa-award',
                name: 'SIREN',
                display: "SIRENSoc",
                nombdd: "societe.siren",
                obligatoire: ["F"],
                remplace: ['SIRETSoc']
            }, {
                icon: 'fas fa-award',
                name: 'SIRET',
                nombdd: "societe.siret",
                display: "SIRETSoc",
                obligatoire: ["R", "T", "F"],
                remplace: ['SIRENSoc']
            }, {
                icon: 'fas fa-award',
                name: 'RCS',
                nombdd: "societe.rcs",
                display: "RCSSoc",
                obligatoire: ["F"]
            }, {
                icon: 'fas fa-award',
                name: 'Ville du greffe',
                nombdd: "societe.ville_greffe",
                display: "VilGrefSoc",
                obligatoire: ["F"]
            }, {
                icon: 'fas fa-award',
                name: "N° d'inscription répertoire des métiers",
                nombdd: "societe.repertoire_metier",
                display: "RepMetSoc",
                obligatoire: ["F"]
            }, {
                icon: 'fas fa-award',
                name: 'NAF/APE',
                nombdd: "societe.naf_ape",
                display: "APESoc",
                obligatoire: ["T", "R", "F"]
            }]
        }, {
            name: 'Banque',
            icon: 'fas fa-money-check-dollar',
            items: [{
                name: 'Nom banque',
                nombdd: "societe.nom_banque",
                display: "NomBQSoc"
            }, {
                name: 'IBAN',
                nombdd: "societe.iban",
                display: "IBANSoc"
            }, {
                name: 'BIC',
                nombdd: "societe.bic",
                display: 'BICSoc'
            }, {
                name: 'Ordre chèque',
                nombdd: "societe.ordre_cheque",
                display: 'OrdreCheque'
            }]
        }, {
            name: 'Code vendeur',
            display: "IDVendeur",
            nombdd: "doc_cpt.id_utilisateur",
            icon: 'fas fa-user-tag',
            obligatoire: ["R", "T"]
        }, {
            name: 'Lien sur les CGV',
            display: "LienCGV",
            nombdd: "doc_cpt.id_cgv",
            icon: 'fas fa-book'
        }],
    }, {
        name: 'Client',
        icon: 'fas fa-home',
        items: [{
            name: 'Nom client',
            display: "NomCli",
            nombdd: "cli.nom",
            obligatoire: ["F"]
        }, {
            icon: 'fas fa-map-location-dot',
            name: 'Adresse client',
            display: "AdrCli",
            nombdd: "cli.ad1",
            obligatoire: ["F"]
        }, {
            icon: 'fas fa-map-location-dot',
            name: 'Code postal client',
            display: "CpCli",
            nombdd: "cli.cp",
            obligatoire: ["F"]
        }, {
            icon: 'fas fa-map-location-dot',
            name: 'Ville client',
            display: "VilCli",
            nombdd: "cli.ville",
            obligatoire: ["F"]
        }, {
            icon: 'fas fa-map-location-dot',
            name: 'Pays client',
            display: "PayCli",
            nombdd: "cli.pays",
            obligatoire: ["F"]
        }, {
            icon: "fas fa-percent",
            name: 'N° de tva intracommunautaire (client pro.)',
            display: "TVAIntraCli",
            nombdd: "cli.tvaintra",
            obligatoire: ["F"]
        }],
    }, {
        name: 'Doc. comptable',
        icon: 'fafa fafa-file-invoice-euro',
        items: [{
            icon: 'fafa fafa-file-invoice-euro',
            name: "Information document",
            items: [{
                icon: 'fafa fafa-file-invoice-euro',
                name: 'N° document',
                display: "NDoc",
                nombdd: "doc_cpt.id_document",
                obligatoire: ["T", "R", "F"],
                presenceObligatoireDansSection: [{ typeDocument: "F", section: ["_entete_page", "_pied_page"] }]
            }, {
                icon: 'fas fa-file',
                name: 'Type de document (Facture, avoir...)',
                display: "TypDoc",
                nombdd: "doc_cpt.type_doc",
                obligatoire: ["T", "R", "F"]
            }, {
                icon: 'fas fa-cog',
                name: 'Type opération (Vente...)',
                display: "TypOpeDoc",
                nombdd: "doc_cpt.type_operation",
                obligatoire: ["T", "R"]
            }, {
                icon: 'fas fa-calendar',
                name: 'Date document',
                nombdd: "doc_cpt.date_document",
                display: "DateDoc",
                obligatoire: ["T", "R", "F"]
            }, {
                icon: 'fas fa-hand-holding-dollar',
                name: 'Nbre de ligne de vente',
                nombdd: "doc_cpt.nb_lig_vente",
                display: "NbLigVteDoc",
                obligatoire: ["T", "R"]
            }, {
                icon: 'fas fa-hand-holding-dollar',
                name: 'Date fin validité document',
                nombdd: "doc_cpt.date_validite",
                display: "dateValide",
                obligatoire: ["D", "C"],
                interdit: ["F", "T", "R"]
            }, {
                icon: 'fas fa-file',
                name: 'N° doc. source de la facture (cde, devis...) ou destination (facture...)',
                nombdd: "doc_cpt.id_doc_source",
                display: "NDocSource",
            }]
        }, {
            icon: 'fas fa-arrow-trend-down',
            name: "Remise",
            items: [{
                icon: 'fas fa-arrow-trend-down',
                name: 'Taux remise pied',
                nombdd: "doc_cpt.taux_remise",
                display: "TxRemisePied"
            }, {
                icon: 'fas fa-arrow-trend-down',
                name: 'Total remise pied',
                nombdd: "doc_cpt.mt_remise_ttc",
                display: "TotRemisePied"
            }, {
                icon: 'fas fa-arrow-trend-down',
                name: 'Ligne remise pied [Total Ht: HTAvantRemisePied€ - Remise X% : -TOT€] (affiché uniquement si remise pied)',
                nombdd: "doc_cpt.phrase_remise",
                display: "PhRemisePied"
            }]
        }, {
            icon: "fas fa-dollar-sign",
            name: 'Total HT',
            items: [{
                icon: "fas fa-dollar-sign",
                name: 'Total HT sans remise',
                display: "TotHTSsRemiseDoc",
                nombdd: "doc_cpt.totht_sans_remise",
                interdit: ["R"]
            }, {
                icon: "fas fa-dollar-sign",
                name: 'Total HT avec remise ligne',
                nombdd: "doc_cpt.totht_sans_remise_pied",
                display: "TotHTAvRemiseLigDoc",
                interdit: ["R"]
            }, {
                icon: "fas fa-dollar-sign",
                name: 'Total HT avec remise ligne & pied',
                nombdd: "doc_cpt.totht_avec_remise_pied",
                display: "TotHTAvRemiseLigPiedDoc",
                obligatoire: ["T", "F"],
                interdit: ["R"]
            }]
        }, {
            icon: "fas fa-percent",
            name: "TVA",
            htttc: ["TTC"],
            items: [{
                icon: "fas fa-percent",
                name: 'Total TVA',
                display: "TotTVADoc",
                nombdd: "doc_cpt.tottva_avec_remise_pied",
                obligatoire: ["F"],
                interdit: ["R"]
            }, {
                icon: "fas fa-percent",
                name: 'Tableau récapitulatif des TVAs',
                display: "RecapTVADoc",
                nombdd: "doc_cpt.recap_tva",
                obligatoire: ["T", "F"],
                interdit: ["R"]
            }]
        }, {
            icon: "fafa fafa-file-invoice-euro",
            name: 'Total TTC',
            htttc: ["TTC"],
            items: [{
                icon: "fafa fafa-file-invoice-euro",
                name: 'Total TTC sans remise',
                nombdd: "doc_cpt.totht_sans_remise",
                display: "TotTTCSsRemiseDoc"
            }, {
                icon: "fafa fafa-file-invoice-euro",
                name: 'Total TTC avec remise ligne',
                nombdd: "doc_cpt.totttc_sans_remise_pied",
                display: "TotTTCAvRemiseLigDoc"
            }, {
                icon: "fafa fafa-file-invoice-euro",
                name: 'Total TTC avec remise ligne et pied',
                nombdd: "doc_cpt.totttc_avec_remise_pied",
                display: "TotTTCAvRemiseLigPiedDoc",
                obligatoire: ["T", "R", "F"]
            }]
        }, {
            icon: "fas fa-money-check",
            name: 'Tableau récapitulatif des règlements',
            nombdd: "doc_cpt.recap_reglement",
            display: "RecapRegDoc",
            obligatoire: ["T"],
            interdit: ["R"]
        }, {
            icon: "fas fa-money-check",
            name: 'Reste à payer',
            nombdd: "doc_cpt.reste_a_payer",
            display: "ResteAPayer"
        }, {
            icon: "fas fa-credit-card",
            name: 'QrCode de reglement CB',
            nombdd: "doc_cpt.qrcodecb",
            display: "QrCodeCB",
            interdit: ["R", "T"]
        }, {
            icon: 'fas fa-user-shield',
            name: "Précisions réglementaires",
            items: [{
                icon: 'fas fa-user-shield',
                name: 'Phrase de délais de paiement',
                nombdd: "societe.phrase_delai_paiement",
                display: "DelaiPayDoc",
                obligatoire: ["F"]
            }, {
                icon: 'fas fa-user-shield',
                name: 'Montant indemnité forfaitaire',
                nombdd: "societe.phrase_mt_indemn_forfaitaire",
                display: "MtIndemnDoc",
                defaut: "En cas d’impayés ou de rejet de chèque pour défaut de provision, les sommes recouvrées seront majorées à titre de clause pénale d’une somme forfaitaire de 40 euros.",
                obligatoire: ["F"]
            }, {
                icon: 'fas fa-user-shield',
                name: 'Taux pénalité de retard',
                display: "TxPenalDoc",
                nombdd: "societe.phrase_penalite_retard",
                défaut: "Des pénalités de retard égales à trois fois le taux d’intérêt légal en vigueur au jour de la facture seront applicables en cas de paiement postérieur à la date d’échéance figurant sur la facture.",
                obligatoire: ["F"]
            }, {
                icon: 'fas fa-file-contract',
                name: "Signature unique document",
                nombdd: "doc_cpt.signature_display",
                display: "SignDoc",
                obligatoire: ["T", "F"],
                interdit: ["D", "C", "R"]
            }, {
                icon: 'fas fa-receipt',
                name: "info impression/duplicata",
                display: "InfoImpDuplicataDoc",
                nombdd: "doc_cpt.info_duplicata",
                obligatoire: ["T", "R", "F"]
            }]
        }, {
            icon: 'fas fa-highlighter',
            name: "Note",
            items: [{
                icon: 'fas fa-highlighter',
                name: 'Note de haut de page',
                nombdd: "doc_cpt.note1",
                display: "Not1Doc"
            }, {
                icon: 'fas fa-highlighter',
                name: 'Note de bas de page',
                nombdd: "doc_cpt.note2",
                display: "Not2Doc"
                //}, {
                //    icon: 'fas fa-highlighter',
                //    name: 'Note 3',
                //    display: "Not3Doc"
                //}, {
                //    icon: 'fas fa-highlighter',
                //    name: 'Note 4',
                //    display: "Not4Doc"
            }]
        }]
    }, {
        name: 'Divers',
        icon: 'fas fa-cog',
        items: [{
            name: 'Nom logiciel',
            display: "NomLogDoc",
            nombdd: "log.nom",
            obligatoire: ["T", "R", "F"]
        }, {
            name: 'Version logiciel',
            display: "VerLogDoc",
            nombdd: "log.version",
            obligatoire: ["T", "R", "F"]
        }]
    }]
    mAddType("doc", { items: this.lstChampPage })

    this.lstChampLigne = [{
        name: 'Ligne',
        icon: "fas fa-bars-staggered",
        items: [{
            name: 'Image article',
            icon: "fas fa-image",
            display: "ImgProdLig",
            nombdd: "doc_cpt_ligne.image",
            interdit: ["T", "R"]
        }, {
            icon: 'fas fa-barcode',
            name: 'Libellé ligne',
            display: "LibLig",
            nombdd: "doc_cpt_ligne.nom_article",
            obligatoire: ["T", "R", "F"]
        }, {
            icon: 'fas fa-barcode',
            name: 'Code article',
            nombdd: "doc_cpt_ligne.id_article",
            display: "IDProd"
        }, {
            name: 'Quantité',
            display: "QtéLig",
            nombdd: "doc_cpt_ligne.qte",
            obligatoire: ["T", "R", "F"]
        }, {
            icon: 'fas fa-circle-dollar-to-slot',
            name: "Prix unitaire",
            items: [{
                icon: 'fas fa-circle-dollar-to-slot',
                name: 'Prix unitaire HT',
                nombdd: "doc_cpt_ligne.puht",
                display: "PUHTLig",
                obligatoire: ["F"],
                interdit: ["R"]
            }, {
                icon: 'fas fa-circle-dollar-to-slot',
                name: 'Prix unitaire TTC',
                nombdd: "doc_cpt_ligne.puttc",
                display: "PUTTCLig",
                obligatoire: ["T"],
                htttc: ["TTC"]
            }]
        }, {
            icon: 'fas fa-arrow-trend-down',
            name: "Remise ligne",
            items: [{
                icon: 'fas fa-arrow-trend-down',
                name: 'Taux remise',
                nombdd: "doc_cpt_ligne.taux_remise",
                display: "TxRemiseLig",
                obligatoire: ["T", "F"],
                remplace: ['PhRemiseLig']
            }, {
                icon: 'fas fa-arrow-trend-down',
                name: 'Total remise',
                nombdd: "doc_cpt_ligne.mt_remise_ttc",
                display: "TotRemiseLig",
                obligatoire: ["T", "F"],
                remplace: ['PhRemiseLig']
            }, {
                icon: 'fas fa-arrow-trend-down',
                name: 'Phrase remise ligne [Remise X% : TOT€] (affiché uniquement si remise ligne)',
                nombdd: "doc_cpt_ligne.phrase_remise",
                display: "PhRemiseLig",
                obligatoire: ["T", "F"],
                remplace: ['TxRemiseLig', 'TotRemiseLig']
            }]
        }, {
            icon: "fas fa-dollar-sign",
            name: 'Total HT',
            display: "TotHTLig",
            items: [{
                icon: "fas fa-dollar-sign",
                name: "Total HT sans remise",
                nombdd: "doc_cpt_ligne.totht_sans_remise",
                display: "TotHtSsRemiseLig",
                interdit: ["R"]
            }, {
                icon: "fas fa-dollar-sign",
                name: "Total HT avec remise ligne",
                nombdd: "doc_cpt_ligne.totht_sans_remise_pied",
                display: "TotHtRemiseLig",
                interdit: ["R"]
            }, {
                icon: "fas fa-dollar-sign",
                name: "Total HT avec remise ligne & pied",
                nombdd: "doc_cpt_ligne.totht_avec_remise_pied",
                display: "TotHtRemiseLigPied",
                interdit: ["R"]
            }]
        }, {
            icon: "fas fa-percent",
            name: "TVA",
            htttc: ["TTC"],
            items: [{
                icon: "fas fa-percent",
                name: 'Code TVA',
                nombdd: "doc_cpt_ligne.id_tva",
                display: "IDTVALig",
                obligatoire: ["T"],
                interdit: ["R"]
            }, {
                icon: "fas fa-percent",
                name: 'Taux TVA',
                nombdd: "doc_cpt_ligne.taux_tva",
                display: "TxTVALig",
                obligatoire: ["F", "T"],
                interdit: ["R"]
            }, {
                icon: "fas fa-percent",
                name: 'Libellé TVA',
                nombdd: "doc_cpt_ligne.nom_tva",
                display: "LibTVALig",
                interdit: ["R"]
            }, {
                icon: "fas fa-percent",
                name: 'Total TVA',
                nombdd: "doc_cpt_ligne.tottva_avec_remise_pied",
                display: "TotTVALig",
                interdit: ["R"]
            }]
        }, {
            icon: "fafa fafa-file-invoice-euro",
            name: 'Total TTC',
            display: "TotTTCLig",
            htttc: ["TTC"],
            items: [{
                icon: "fafa fafa-file-invoice-euro",
                name: 'Total TTC sans remise',
                nombdd: "doc_cpt_ligne.totttc_sans_remise",
                display: "TotTTCSsRemiseLig"
            }, {
                icon: "fafa fafa-file-invoice-euro",
                name: 'Total TTC avec remise ligne',
                nombdd: "doc_cpt_ligne.totttc_sans_remise_pied",
                display: "TotTTCRemiseLig",
                obligatoire: ["T"]
            }, {
                icon: "fafa fafa-file-invoice-euro",
                name: 'Total TTC avec remise ligne & pied',
                nombdd: "doc_cpt_ligne.totttc_avec_remise_pied",
                display: "TotTTCRemiseLigPied"
            }]
        }, {
            icon: 'fas fa-highlighter',
            name: 'Note ligne',
            nombdd: "doc_cpt_ligne.note",
            display: "NotLig"
        }],
    }]
    mAddType("lig", { items: this.lstChampLigne })

    function mAddType(typ, item) {
        item.type = typ
        if (typeof item.items != 'undefined') {
            item.items.forEach(function (SSitem) { mAddType(typ, SSitem) })
        }
    }

    this.mGetTotalRemiseTtc = function (lstLigne) {
        var totRemise = parseFloat(objet.data.mt_remise_ttc)
        lstLigne.forEach(function (lig) {
            totRemise += parseFloat(lig.mt_remise_ttc)
        })
        return totRemise
    }

    this.mRecalculLigne = function (lstLigneOriginal, lstReglement, funcOk) {
        lstLigneOriginal.forEach(function (ligne) {
            var tva = Me.objet.bddRef.getObjet("tva", ligne.id_tva)
            ligne.taux_tva = ((typeof tva.data == 'undefined') ? 0 : tva.data.taux)
            ligne.nom_tva = ((typeof tva.data == 'undefined') ? "" : tva.data.nom)
            if (typeof tva.data == 'undefined') {
                ligne.puttc = ligne.puht
            } else {
                ligne.puttc = Math.round((parseFloat(ligne.puht) + parseFloat(ligne.puht) * tva.objetMetier.mGetTauxTva() / 100) * 100) / 100
            }

            //mode_ttc toujours à 0 (pas géré en parametrage)
            if (Me.mGetSociete().mode_ttc == "1") {
                ligne.totttc_sans_remise = parseFloat(ligne.puttc) * parseFloat(ligne.qte)
                ligne.tottva_sans_remise = parseFloat(ligne.totttc_sans_remise) - parseFloat(ligne.totttc_sans_remise) / (1 + tva.objetMetier.mGetTauxTva() / 100)
                ligne.totht_sans_remise = parseFloat(ligne.totttc_sans_remise) - ligne.tottva_sans_remise
            } else {
                ligne.totht_sans_remise = parseFloat(ligne.puht) * parseFloat(ligne.qte)
                ligne.tottva_sans_remise = parseFloat(ligne.totht_sans_remise) * tva.objetMetier.mGetTauxTva() / 100
                ligne.totttc_sans_remise = parseFloat(ligne.totht_sans_remise) + ligne.tottva_sans_remise
            }
            switch (parseInt(ligne.type_remise)) {
                case 0: //aucune remise
                    ligne.totttc_sans_remise_pied = ligne.totttc_sans_remise;
                    break;
                case 1: //pourcentage
                    ligne.taux_remise = ligne.taux_mt_remise
                    ligne.mt_remise_ttc = ligne.totttc_sans_remise * (ligne.taux_mt_remise / 100)
                    ligne.totttc_sans_remise_pied = ligne.totttc_sans_remise - ligne.mt_remise_ttc
                    break;
                case 2: //montant
                    ligne.taux_remise = ligne.taux_mt_remise / ligne.totttc_sans_remise * 100
                    ligne.mt_remise_ttc = ligne.taux_mt_remise
                    ligne.totttc_sans_remise_pied = ligne.totttc_sans_remise - ligne.taux_mt_remise
                    break;
            }
            ligne.tottva_sans_remise_pied = ligne.totttc_sans_remise_pied - parseFloat(ligne.totttc_sans_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)
            ligne.totht_sans_remise_pied = ligne.totttc_sans_remise_pied - ligne.tottva_sans_remise_pied
        })

        objet.data.nb_ligne_vente = lstLigneOriginal.length;

        lstLigneOriginal.forEach(function (lig) {
            if (lig.nom_article == null) {
                var obj = Me.objet.bddRef.getObjet("article", lig.id_article)
                lig.nom_article = ((obj.data.nom == null) ? "" : obj.data.nom)
            }
        })


        objet.data.totht_sans_remise = 0
        objet.data.tottva_sans_remise = 0
        objet.data.totttc_sans_remise = 0
        lstLigneOriginal.forEach(function (lig) {
            objet.data.totht_sans_remise += parseFloat(lig.totht_sans_remise_pied)
            objet.data.tottva_sans_remise += parseFloat(lig.tottva_sans_remise_pied)
            objet.data.totttc_sans_remise += parseFloat(lig.totttc_sans_remise_pied)
        })

        //dispatch TVA & remise pied
        objet.data.totht_sans_remise_pied = 0
        objet.data.tottva_sans_remise_pied = 0
        objet.data.totttc_sans_remise_pied = 0
        objet.data.totht_avec_remise_pied = 0
        objet.data.tottva_avec_remise_pied = 0
        objet.data.totttc_avec_remise_pied = 0
        if (objet.data.type_remise == 0) {
            lstLigneOriginal.forEach(function (lig) {
                lig.totht_avec_remise_pied = parseFloat(lig.totht_sans_remise_pied)
                lig.tottva_avec_remise_pied = parseFloat(lig.tottva_sans_remise_pied)
                lig.totttc_avec_remise_pied = parseFloat(lig.totht_avec_remise_pied) + parseFloat(lig.tottva_avec_remise_pied)
                objet.data.totht_sans_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                objet.data.tottva_sans_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                objet.data.totttc_sans_remise_pied += parseFloat(lig.totttc_avec_remise_pied)

                objet.data.totht_avec_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                objet.data.tottva_avec_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                objet.data.totttc_avec_remise_pied += parseFloat(lig.totttc_avec_remise_pied)
            })
        } else {
            lstLigneOriginal.forEach(function (lig) {
                objet.data.totht_sans_remise_pied += parseFloat(lig.totht_sans_remise_pied)
                objet.data.tottva_sans_remise_pied += parseFloat(lig.tottva_sans_remise_pied)
                objet.data.totttc_sans_remise_pied += parseFloat(lig.totttc_sans_remise_pied)
            })
            var mtRemisePiedTtc = 0
            if (objet.data.type_remise == 1) {
                mtRemisePiedTtc = parseFloat(objet.data.totttc_sans_remise) * objet.data.taux_mt_remise / 100
                objet.data.taux_remise = objet.data.taux_mt_remise
                objet.data.mt_remise_ttc = mtRemisePiedTtc
            } else {
                mtRemisePiedTtc = objet.data.taux_mt_remise
                objet.data.taux_remise = parseFloat(objet.data.totttc_sans_remise) / objet.data.taux_mt_remise * 100
                objet.data.mt_remise_ttc = objet.data.taux_mt_remise
            }
            var relicat = mtRemisePiedTtc
            lstLigneOriginal.forEach(function (lig) {
                var partRemisePied = Math.round(mtRemisePied / parseFloat(objet.data.totht_sans_remise) * lig.totht_sans_remise_pied * 100) / 100
                lig.totttc_avec_remise_pied = lig.totttc_sans_remise_pied - partRemisePied
                if (lig.id_tva != null) {
                    var tva = Me.objet.bddRef.getObjet("tva", lig.id_tva)
                    lig.tottva_avec_remise_pied = lig.totttc_avec_remise_pied - parseFloat(lig.totttc_avec_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)
                    lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied - lig.tottva_avec_remise_pied
                } else {
                    lig.tottva_avec_remise_pied = 0
                    lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied
                }
                relicat -= partRemisePied
            })
            relicat = Math.round(relicat * 100) / 100
            var idx = 0
            while (relicat != 0) {
                idx += 1
                if (idx == 1000) {
                    debugger;
                    break;
                }
                lstLigneOriginal.forEach(function (lig) {
                    if (relicat != 0) {
                        var enleve = -0.01
                        if (relicat < 0) enleve = 0.01
                        objet.data.totttc_avec_remise_pied += enleve
                        relicat += enleve
                        relicat = Math.round(relicat * 100) / 100
                    }
                })
            }
            //on recalcul les TVA aprés avoir dispatché la remise pied
            lstLigneOriginal.forEach(function (lig) {
                if (lig.id_tva != null) {
                    var tva = Me.objet.bddRef.getObjet("tva", lig.id_tva)
                    lig.tottva_avec_remise_pied = lig.totttc_avec_remise_pied - parseFloat(lig.totttc_avec_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)
                    lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied - lig.tottva_avec_remise_pied
                } else {
                    lig.tottva_avec_remise_pied = 0
                    lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied
                }
            })
            lstLigneOriginal.forEach(function (lig) {
                objet.data.totht_avec_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                objet.data.tottva_avec_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                objet.data.totttc_avec_remise_pied += parseFloat(lig.totttc_avec_remise_pied)
            })
        }

        objet.data.totttc_avec_remise_pied = Math.round(parseFloat(objet.data.totttc_avec_remise_pied) * 100) / 100

        if (typeof lstReglement == 'undefined' || lstReglement == null) {
            //Me.objet.bddRef.mAjaxCall({ command: "getdatas", nomtable: "doc_cpt_mode_reglement", sql: "select * from doc_cpt_mode_reglement where id_doc_cpt=" + objet.data.id_doc_cpt + " and id_historique_sup is null" }, function (data) {
            Me.objet.bddRef.mAjaxCall({ command: "getdatasdoccptreglement", id: objet.data.id_doc_cpt }, function (data) {
                data.doc_cpt_mode_reglement = JSON.parse(data.doc_cpt_mode_reglement)
                lstReglement = ((typeof data.doc_cpt_mode_reglement == 'undefined') ? [] : data.doc_cpt_mode_reglement);
                mFinalise()
            });
        } else { mFinalise() }

        function mFinalise() {
            //calcul reste à payer
            var resteAPayer = objet.data.totttc_avec_remise_pied
            lstReglement.forEach(function (reg) {
                resteAPayer = resteAPayer - reg.mt
            })
            objet.data.reste_a_payer = resteAPayer

            var lstData = [objet.data]
            lstLigneOriginal.forEach(function (lig) {
                lstData.push(lig)
            })
            lstReglement.forEach(function (ligReg) {
                lstData.push(ligReg)
            })
            var objs = Me.objet.bddRef.getObjets()
            objs.mAddData(lstData, "save")
            objs.mSave(funcOk)
        }

    }

    this.mRecalculLigneDetail = function (docCptDetail, funcOk) {
        if (docCptDetail.docCpt.id_statut_com == "1") {
            //on recalcul les lignes 
        }
        docCptDetail.docCptLigne.forEach(function (ligne) {
            var tva = Me.objet.bddRef.getObjet("tva", ligne.id_tva)
            ligne.taux_tva = ((typeof tva.data == 'undefined') ? 0 : tva.data.taux)
            ligne.nom_tva = ((typeof tva.data == 'undefined') ? "" : tva.data.nom)
            if (typeof tva.data == 'undefined') {
                ligne.puttc = ligne.puht
            } else {
                ligne.puttc = Math.round((parseFloat(ligne.puht) + parseFloat(ligne.puht) * tva.objetMetier.mGetTauxTva() / 100) * 100) / 100
            }

            //mode_ttc toujours à 0 (pas géré en parametrage)
            if (Me.mGetSociete().mode_ttc == "1") {
                ligne.totttc_sans_remise = parseFloat(ligne.puttc) * parseFloat(ligne.qte)
                ligne.tottva_sans_remise = parseFloat(ligne.totttc_sans_remise) - parseFloat(ligne.totttc_sans_remise) / (1 + tva.objetMetier.mGetTauxTva() / 100)
                ligne.totht_sans_remise = parseFloat(ligne.totttc_sans_remise) - ligne.tottva_sans_remise
            } else {
                ligne.totht_sans_remise = parseFloat(ligne.puht) * parseFloat(ligne.qte)
                ligne.tottva_sans_remise = parseFloat(ligne.totht_sans_remise) * tva.objetMetier.mGetTauxTva() / 100
                ligne.totttc_sans_remise = parseFloat(ligne.totht_sans_remise) + ligne.tottva_sans_remise
            }
            switch (parseInt(ligne.type_remise)) {
                case 0: //aucune remise
                    ligne.totttc_sans_remise_pied = ligne.totttc_sans_remise;
                    break;
                case 1: //pourcentage
                    ligne.taux_remise = ligne.taux_mt_remise
                    ligne.mt_remise_ttc = ligne.totttc_sans_remise * (ligne.taux_mt_remise / 100)
                    ligne.totttc_sans_remise_pied = ligne.totttc_sans_remise - ligne.mt_remise_ttc
                    break;
                case 2: //montant
                    ligne.taux_remise = ligne.taux_mt_remise / ligne.totttc_sans_remise * 100
                    ligne.mt_remise_ttc = ligne.taux_mt_remise
                    ligne.totttc_sans_remise_pied = ligne.totttc_sans_remise - ligne.taux_mt_remise
                    break;
            }
            ligne.tottva_sans_remise_pied = ligne.totttc_sans_remise_pied - parseFloat(ligne.totttc_sans_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)
            ligne.totht_sans_remise_pied = ligne.totttc_sans_remise_pied - ligne.tottva_sans_remise_pied
        })

        docCptDetail.docCpt.nb_ligne_vente = docCptDetail.docCptLigne.length;

        docCptDetail.docCptLigne.forEach(function (lig) {
            if (lig.nom_article == null) {
                var obj = Me.objet.bddRef.getObjet("article", lig.id_article)
                lig.nom_article = ((obj.data.nom == null) ? "" : obj.data.nom)
            }
        })


        docCptDetail.docCpt.totht_sans_remise = 0
        docCptDetail.docCpt.tottva_sans_remise = 0
        docCptDetail.docCpt.totttc_sans_remise = 0
        docCptDetail.docCptLigne.forEach(function (lig) {
            docCptDetail.docCpt.totht_sans_remise += parseFloat(lig.totht_sans_remise_pied)
            docCptDetail.docCpt.tottva_sans_remise += parseFloat(lig.tottva_sans_remise_pied)
            docCptDetail.docCpt.totttc_sans_remise += parseFloat(lig.totttc_sans_remise_pied)
        })

        //dispatch TVA & remise pied
        docCptDetail.docCpt.totht_sans_remise_pied = 0
        docCptDetail.docCpt.tottva_sans_remise_pied = 0
        docCptDetail.docCpt.totttc_sans_remise_pied = 0
        docCptDetail.docCpt.totht_avec_remise_pied = 0
        docCptDetail.docCpt.tottva_avec_remise_pied = 0
        docCptDetail.docCpt.totttc_avec_remise_pied = 0
        if (docCptDetail.docCpt.type_remise == 0) {
            docCptDetail.docCptLigne.forEach(function (lig) {
                lig.totht_avec_remise_pied = parseFloat(lig.totht_sans_remise_pied)
                lig.tottva_avec_remise_pied = parseFloat(lig.tottva_sans_remise_pied)
                lig.totttc_avec_remise_pied = parseFloat(lig.totht_avec_remise_pied) + parseFloat(lig.tottva_avec_remise_pied)
                docCptDetail.docCpt.totht_sans_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                docCptDetail.docCpt.tottva_sans_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                docCptDetail.docCpt.totttc_sans_remise_pied += parseFloat(lig.totttc_avec_remise_pied)

                docCptDetail.docCpt.totht_avec_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                docCptDetail.docCpt.tottva_avec_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                docCptDetail.docCpt.totttc_avec_remise_pied += parseFloat(lig.totttc_avec_remise_pied)
            })
        } else {
            docCptDetail.docCptLigne.forEach(function (lig) {
                docCptDetail.docCpt.totht_sans_remise_pied += parseFloat(lig.totht_sans_remise_pied)
                docCptDetail.docCpt.tottva_sans_remise_pied += parseFloat(lig.tottva_sans_remise_pied)
                docCptDetail.docCpt.totttc_sans_remise_pied += parseFloat(lig.totttc_sans_remise_pied)
            })
            var mtRemisePiedTtc = 0
            if (docCptDetail.docCpt.type_remise == 1) {
                mtRemisePiedTtc = parseFloat(docCptDetail.docCpt.totttc_sans_remise) * docCptDetail.docCpt.taux_mt_remise / 100
                docCptDetail.docCpt.taux_remise = docCptDetail.docCpt.taux_mt_remise
                docCptDetail.docCpt.mt_remise_ttc = mtRemisePiedTtc
            } else {
                mtRemisePiedTtc = docCptDetail.docCpt.taux_mt_remise
                docCptDetail.docCpt.taux_remise = parseFloat(docCptDetail.docCpt.totttc_sans_remise) / docCptDetail.docCpt.taux_mt_remise * 100
                docCptDetail.docCpt.mt_remise_ttc = docCptDetail.docCpt.taux_mt_remise
            }
            var relicat = mtRemisePiedTtc
            docCptDetail.docCptLigne.forEach(function (lig) {
                var partRemisePied = Math.round(mtRemisePiedTtc / parseFloat(docCptDetail.docCpt.totht_sans_remise) * lig.totht_sans_remise_pied * 100) / 100
                lig.totttc_avec_remise_pied = lig.totttc_sans_remise_pied - partRemisePied
                if (lig.id_tva != null) {
                    var tva = Me.objet.bddRef.getObjet("tva", lig.id_tva)
                    lig.tottva_avec_remise_pied = lig.totttc_avec_remise_pied - parseFloat(lig.totttc_avec_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)
                    lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied - lig.tottva_avec_remise_pied
                } else {
                    lig.tottva_avec_remise_pied = 0
                    lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied
                }
                relicat -= partRemisePied
            })
            relicat = Math.round(relicat * 100) / 100
            var idx = 0
            while (relicat != 0) {
                idx += 1
                if (idx == 1000) {
                    debugger;
                    break;
                }
                docCptDetail.docCptLigne.forEach(function (lig) {
                    if (relicat != 0) {
                        var enleve = -0.01
                        if (relicat < 0) enleve = 0.01
                        docCptDetail.docCpt.totttc_avec_remise_pied += enleve
                        relicat += enleve
                        relicat = Math.round(relicat * 100) / 100
                    }
                })
            }
            //on recalcul les TVA aprés avoir dispatché la remise pied
            docCptDetail.docCptLigne.forEach(function (lig) {
                if (lig.id_tva != null) {
                    var tva = Me.objet.bddRef.getObjet("tva", lig.id_tva)
                    lig.tottva_avec_remise_pied = lig.totttc_avec_remise_pied - parseFloat(lig.totttc_avec_remise_pied) / (1 + tva.objetMetier.mGetTauxTva() / 100)
                    lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied - lig.tottva_avec_remise_pied
                } else {
                    lig.tottva_avec_remise_pied = 0
                    lig.totht_avec_remise_pied = lig.totttc_avec_remise_pied
                }
            })
            docCptDetail.docCptLigne.forEach(function (lig) {
                docCptDetail.docCpt.totht_avec_remise_pied += parseFloat(lig.totht_avec_remise_pied)
                docCptDetail.docCpt.tottva_avec_remise_pied += parseFloat(lig.tottva_avec_remise_pied)
                docCptDetail.docCpt.totttc_avec_remise_pied += parseFloat(lig.totttc_avec_remise_pied)
            })
        }

        docCptDetail.docCpt.totttc_avec_remise_pied = Math.round(parseFloat(docCptDetail.docCpt.totttc_avec_remise_pied) * 100) / 100

        //calcul reste à payer
        var resteAPayer = docCptDetail.docCpt.totttc_avec_remise_pied
        docCptDetail.docCptModeReglement.forEach(function (reg) {
            resteAPayer = resteAPayer - reg.mt
        })
        docCptDetail.docCpt.reste_a_payer = resteAPayer

        var lstData = [docCptDetail.docCpt]
        docCptDetail.docCptLigne.forEach(function (lig) {
            lstData.push(lig)
        })
        docCptDetail.docCptModeReglement.forEach(function (ligReg) {
            lstData.push(ligReg)
        })
        var objs = Me.objet.bddRef.getObjets()
        objs.mAddData(lstData, "save")
        objs.mSave(funcOk)
        //}

    }

    this.mGetDocCptDetail = function (idDocCpt, funcOk) {
        Me.objet.bddRef.mAjaxCall({ command: "getdoccpt", id_doc_cpt: idDocCpt }, function (data) {
            var docCptDetail = {
                docCpt: data.doc_cpt[0],
                docCptClient: data.doc_cpt_client[0],
                docCptSociete: data.doc_cpt_societe[0],
                docCptLigne: ((typeof data.doc_cpt_ligne == 'undefined') ? [] : data.doc_cpt_ligne),
                docCptModeReglement: ((typeof data.doc_cpt_mode_reglement == 'undefined') ? [] : data.doc_cpt_mode_reglement)
            }
            funcOk(docCptDetail)
        })
    }

    this.mGetLstDocCptBrouillon = function (societe, idTypeCom, funcOk) {
        //Me.objet.bddRef.mAjaxCall({ command: "getdatas", nomtable: "doc_cpt", sql: "select * from doc_cpt where id_statut_com=1 and id_societe=" + societe.id_societe + " and id_historique_sup is null " + ((typeof idTypeCom != 'undefined' && idTypeCom != null) ? " and id_type_com=" + idTypeCom : "") }, function (data) {
        Me.objet.bddRef.mAjaxCall({ command: "getdatasdoccptbrouillon", idsociete: societe.id_societe, idtypecom: idTypeCom }, function (data) {
            data.doc_cpt = JSON.parse(data.doc_cpt)
            //var lstDocCpt = ((typeof data.doc_cpt == 'undefined') ? [] : data.doc_cpt);
            funcOk(data.doc_cpt)
        });
    }

    this.mMigreDocCptBrouillonTva = function (societe, puTTCEgalePuHt, funcOk) {
        Me.objet.bddRef.mAjaxCall({ command: "getdatasdoccptbrouillon", idsociete: societe.id_societe }, function (data) {
            data.doc_cpt = JSON.parse(data.doc_cpt)
            //var lstDocCpt = ((typeof data.doc_cpt == 'undefined') ? [] : data.doc_cpt);
            mRecalcul(0)
            function mRecalcul(idx) {
                if (typeof lstDocCpt[idx] != 'undefined') {
                    var docCpt = lstDocCpt[idx]
                    //Me.objet.bddRef.mAjaxCall({ command: "getdatas", nomtable: "doc_cpt_ligne", sql: "select * from doc_cpt_ligne where id_doc_cpt=" + docCpt.id_doc_cpt + " and id_historique_sup is null" }, function (data) {
                    Me.objet.bddRef.mAjaxCall({ command: "getdatasdoccptligne", id: docCpt.id_doc_cpt }, function (data) {
                        data.doc_cpt_ligne = JSON.parse(data.doc_cpt_ligne)
                        lstLigne = ((typeof data.doc_cpt_ligne == 'undefined') ? [] : data.doc_cpt_ligne);
                        lstLigne.forEach(function (ligne) {
                            if (societe.assujetti_tva == "1") {
                                var dataArticle = Me.objet.bddRef.getObjet("article", ligne.id_article).data
                                ligne.id_tva = dataArticle.id_tva
                                if (puTTCEgalePuHt) {
                                    var dataTva = Me.objet.bddRef.getObjet(dataArticle).objetMetier.mGetDataTva()
                                    var tauxTva = Me.objet.bddRef.getObjet(dataArticle).objetMetier.mGetTauxTva()
                                    ligne.puht = Math.round(parseFloat(ligne.puttc / (1 + tauxTva / 100)) * 100) / 100
                                }
                            } else {
                                ligne.id_tva = Me.objet.bddRef.getObjet("tva").objetMetier.mGetTvaTaux0().id_tva;
                            }
                        })
                        Me.objet.bddRef.getObjet(docCpt).objetMetier.mRecalculLigne(lstLigne, null, function () {
                            mRecalcul(idx + 1)
                        })
                    });
                } else { funcOk() }
            }
        });
    }

    this.mGetTotTtcAvecRemisePied = function (idDocCpt, funcOk) {
        Me.objet.bddRef.mAjaxCall({ command: "getttcdoccpt", id_doc_cpt: idDocCpt }, function (data) {
            if (typeof funcOk != 'undefined' && funcOk != null) funcOk(parseFloat(data.totttc))
        })
    }

    this.mGetLstResumeTva = function (lstLigne) {
        var lstResumeTva = []
        lstLigne.forEach(function (lig) {
            if (lig.id_tva != null) {
                var tvaResume = lstResumeTva.filter(function (o) { return o.id_tva == lig.id_tva })[0]
                if (typeof tvaResume == 'undefined') {
                    var dataTva = Me.objet.bddRef.getObjet("tva", lig.id_tva).data
                    tvaResume = {
                        id_tva: lig.id_tva,
                        nom: dataTva.nom,
                        taux: parseFloat(dataTva.taux),
                        mt: 0
                    }
                    lstResumeTva.push(tvaResume)
                }
                tvaResume.mt += parseFloat(lig.tottva_avec_remise_pied)
            }
        })
        return lstResumeTva.sort(function (o1, o2) { return o1.taux - o2.taux })
    }

    this.mGetLookUpForFilterBuilderStatutEnvoiPa = function () {
        return {
            dataSource: parametre.lst_statut_envoi_pa,
            displayExpr: "facturx_statut",
            valueExpr: "facturx_id_statut",
            placeholder: "Sélectionner des statuts PA"
        }
    }

    this.mGetLookUpForFilterBuilderStatutReceptionPa = function () {
        return {
            dataSource: parametre.lst_statut_reception_pa,
            displayExpr: "facturx_statut",
            valueExpr: "facturx_id_statut",
            placeholder: "Sélectionner des statuts PA"
        }
    }

}